"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noon = void 0;
const ramda_1 = require("ramda");
/**
 * A function that does nothing
 * @public
 *
 * @returns Value
 *
 * @example
 * ```ts
 * const result = noon()
 * console.log(result)
 * // -> undefined
 * ```
 */
const noon = (0, ramda_1.always)(undefined);
exports.noon = noon;
//# sourceMappingURL=noon.js.map